import { FC } from "react"
import { useTranslation } from "react-i18next"
import browserSvgUrl from "@assets/Browser.svg?url"
export const ErrorView: FC<{ title: string; description: string; action?: React.ReactElement }> = ({
	title,
	description,
	action,
}) => {
	const { t } = useTranslation("components")
	return (
		<div className="electron-drag flex size-full flex-col bg-base-800">
			<div className="relative flex size-full items-center justify-center">
				<img
					className="absolute z-0 mx-auto hidden size-4/5 items-center justify-center sm:block"
					src={browserSvgUrl}
				/>

				<div className="absolute z-10 flex w-full flex-col items-center justify-center space-y-4 px-4 text-center sm:px-0">
					<div className="text-lg">{title}</div>
					<div className="text-sm text-base-400">{description}</div>
					{action}
				</div>
			</div>

			<a
				className="w-fit self-center pb-8 text-center text-sm hover:opacity-50"
				href="https://help.pixieset.com/hc/en-us"
				target="_blank"
				rel="noopener noreferrer"
			>
				{t("errorView.needHelp")}{" "}
				<span className="text-accent-500">{t("errorView.contactUs")}</span>
			</a>
		</div>
	)
}
